const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_EDU_HIGHEST_ID(state, eduHighestId) {
    state.eduHighestId = eduHighestId
  },
  UPDATE_INSTITUTE_NAME(state, eduHighestInstituteName) {
    state.eduHighestInstituteName = eduHighestInstituteName
  },
  UPDATE_COURSE_NAME(state, eduCourseName) {
    state.eduCourseName = eduCourseName
  },
  UPDATE_DURATION_MONTH(state, eduDurationMonth) {
    state.eduDurationMonth = eduDurationMonth
  },
  UPDATE_START_DT(state, eduStartDt) {
    state.eduStartDt = eduStartDt
  },
  UPDATE_END_DT(state, eduEndDt) {
    state.eduEndDt = eduEndDt
  },
  UPDATE_ACHIEVEMENT_UNIT(state, achievementUnitId) {
    state.achievementUnitId = achievementUnitId
  },
  UPDATE_ACHIEVEMENT_RESULT(state, achievementResult) {
    state.achievementResult = achievementResult
  },
  UPDATE_OTHER_ACHIEVEMENT_UNIT(state, otherAchievementUnitId) {
    state.otherAchievementUnitId = otherAchievementUnitId
  },
  UPDATE_OTHER_ACHIEVEMENT_RESULT(state, otherAchievementResult) {
    state.otherAchievementResult = otherAchievementResult
  },
  UPDATE_PROGRAMME(state, programmeId) {
    state.programmeId = programmeId
  },
  // SCHOOL
  UPDATE_SCHOOL_FORM_COMPLETED(state, schoolFormCompleted) {
    state.schoolFormCompleted = schoolFormCompleted;
  },
  UPDATE_SCHOOL_TYPE(state, schoolType) {
    state.schoolType = schoolType
  },
  UPDATE_SCHOOL_TYPE_NAME(state, schoolTypeName) {
    state.schoolTypeName = schoolTypeName
  },
  UPDATE_SCHOOL_NAME(state, schoolName) {
    state.schoolName = schoolName
  },
  UPDATE_SCHOOL_SCORE(state, schoolScore) {
    state.schoolScore = schoolScore
  },
  UPDATE_SPM_YEAR(state, spmYear) {
    state.spmYear = spmYear
  },
  UPDATE_SPM_ANGKA_GILIRAN(state, spmAngkaGiliran) {
    state.spmAngkaGiliran = spmAngkaGiliran
  },
  // COCURRICULUM
  UPDATE_COCURRICULUM_FORM_COMPLETED(state, cocurriculumFormCompleted) {
    state.cocurriculumFormCompleted = cocurriculumFormCompleted;
  },
  UPDATE_COCURRICULUM_SCORE(state, cocurriculumScore) {
    state.cocurriculumScore = cocurriculumScore
  },
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateEduHighest({
    commit
  }, eduHighestId) {
    commit('UPDATE_EDU_HIGHEST_ID', eduHighestId);
  },
  updateInstituteName({
    commit
  }, eduHighestInstituteName) {
    commit('UPDATE_INSTITUTE_NAME', eduHighestInstituteName);
  },
  updateCourseName({
    commit
  }, eduCourseName) {
    commit('UPDATE_COURSE_NAME', eduCourseName);
  },
  updateDurationMonth({
    commit
  }, eduDurationMonth) {
    commit('UPDATE_DURATION_MONTH', eduDurationMonth);
  },
  updateStartDt({
    commit
  }, eduStartDt) {
    commit('UPDATE_START_DT', eduStartDt);
  },
  updateEndDt({
    commit
  }, eduEndDt) {
    commit('UPDATE_END_DT', eduEndDt);
  },
  updateAchievementUnit({
    commit
  }, unit) {
    commit('UPDATE_ACHIEVEMENT_UNIT', unit);
  },
  updateAchievementResult({
    commit
  }, result) {
    commit('UPDATE_ACHIEVEMENT_RESULT', result);
  },
  updateOtherAchievementUnit({
    commit
  }, otherUnit) {
    commit('UPDATE_OTHER_ACHIEVEMENT_UNIT', otherUnit);
  },
  updateOtherAchievementResult({
    commit
  }, otherResult) {
    commit('UPDATE_OTHER_ACHIEVEMENT_RESULT', otherResult);
  },
  updateProgramme({
    commit
  }, programmeId) {
    commit('UPDATE_PROGRAMME', programmeId);
  },
  updateSchoolFormCompleted({
    commit
  }, schoolFormCompleted) {
    commit('UPDATE_SCHOOL_FORM_COMPLETED', schoolFormCompleted)
  },
  updateSchoolType({
    commit
  }, schoolType) {
    commit('UPDATE_SCHOOL_TYPE', schoolType);
  },
  updateSchoolTypeName({
    commit
  }, schoolTypeName) {
    commit('UPDATE_SCHOOL_TYPE_NAME', schoolTypeName);
  },
  updateSchoolName({
    commit
  }, schoolName) {
    commit('UPDATE_SCHOOL_NAME', schoolName);
  },
  updateSchoolScore({
    commit
  }, schoolScore) {
    commit('UPDATE_SCHOOL_SCORE', schoolScore);
  },
  updateSPMYear({
    commit
  }, spmYear) {
    commit('UPDATE_SPM_YEAR', spmYear);
  },
  updateSPMAngkaGiliran({
    commit
  }, spmAngkaGiliran) {
    commit('UPDATE_SPM_ANGKA_GILIRAN', spmAngkaGiliran);
  },
  updateCocurriculumFormCompleted({
    commit
  }, cocurriculumFormCompleted) {
    commit('UPDATE_COCURRICULUM_FORM_COMPLETED', cocurriculumFormCompleted)
  },
  updateCocurriculumScore({
    commit
  }, cocurriculumScore) {
    commit('UPDATE_COCURRICULUM_SCORE', cocurriculumScore);
  },
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  EduHighest: state => {
    return state.eduHighestId
  },
  InstituteName: state => {
    return state.eduHighestInstituteName
  },
  CourseName: state => {
    return state.eduCourseName
  },
  DurationMonth: state => {
    return state.eduDurationMonth
  },
  StartDt: state => {
    return state.eduStartDt
  },
  EndDt: state => {
    return state.eduEndDt
  },
  AchievementUnit: state => {
    return state.achievementUnitId
  },
  AchievementResult: state => {
    return state.achievementResult
  },
  OtherAchievementUnit: state => {
    return state.otherAchievementUnitId
  },
  OtherAchievementResult: state => {
    return state.otherAchievementResult
  },
  Programme: state => {
    return state.programmeId
  },
  SchoolFormCompleted: state => {
    return state.schoolFormCompleted
  },
  SchoolType: state => {
    return state.schoolType
  },
  SchoolTypeName: state => {
    return state.schoolTypeName
  },
  SchoolName: state => {
    return state.schoolName
  },
  SchoolScore: state => {
    return state.schoolScore
  },
  SPMYear: state => {
    return state.spmYear
  },
  SPMAngkaGiliran: state => {
    return state.spmAngkaGiliran
  },
  CocurriculumFormCompleted: state => {
    return state.cocurriculumFormCompleted
  },
  CocurriculumScore: state => {
    return state.cocurriculumScore
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      eduHighestId: 0,
      eduHighestInstituteName: "",
      eduCourseName: "",
      eduDurationMonth: 0,
      eduStartDt: "",
      eduEndDt: "",
      achievementUnitId: 0,
      achievementResult: "",
      otherAchievementUnitId: 0,
      otherAchievementResult: "",
      programmeId: 0,
      schoolFormCompleted: true,
      schoolType: 0,
      schoolTypeName: "",
      schoolName: "",
      schoolScore: 0,
      spmYear: 0,
      spmAngkaGiliran: "",
      cocurriculumFormCompleted: true,
      cocurriculumScore: 0,
    }
  },
  getters,
  actions,
  mutations
}
